import { Component } from "@angular/core";
import { UntypedFormGroup, UntypedFormBuilder, Validators } from "@angular/forms";
import { slideInOutAnimation } from "../animations/router.animations";

import { CustomValidators } from "ng2-validation";

import { UserWebService } from "../services/user.web.service";
import { BaseFormComponent } from "../../../shared/components/base-form.component";
import { UserMessages } from "../constants/messages.constants";
import { RecoveryService } from "../services/recovery.service";

@Component({
  selector: "forgot-password",
  templateUrl: "../templates/forgot-password.html",
  styleUrls: ["../scss/forgot-password.scss"],
  animations: [slideInOutAnimation],
  host: { "[@slideInOutAnimation]": "" },
})
export class ForgotPasswordComponent extends BaseFormComponent {
  email: string;

  success: Array<string> = [];
  errors: Array<string> = [];
  isUser: boolean = true;
  showLoading: boolean;

  constructor(
    private fb: UntypedFormBuilder,
    private userService: UserWebService,
    private recoveryService: RecoveryService
  ) {
    super(
      { email: "", password: "" },
      {
        email: {
          required: UserMessages.EMAIL_REQUIRED,
          email: UserMessages.EMAIL_INVALID,
        },
      },
      fb
    );

    this.email = "";
  }

  ngOnInit() {
    this.buildForm();
  }

  initializeForm(): UntypedFormGroup {
    return this.fb.group({
      email: [
        this.email,
        Validators.compose([Validators.required, CustomValidators.email]),
      ],
    });
  }

  sendForm(): any {
    this.showLoading = true;
    this.email = this.form.value.email;
    return this.recoveryService.requestRecovery(this.email).subscribe(
      (res) => {
        this.handleSuccess(res);
      },
      (res) => {
        this.handleErrors(res);
      }
    );
  }

  handleSuccess(res: any) {
    this.errors = [];
    this.success = res.messages;
    this.showLoading = false;
  }

  handleErrors(errors) {
    this.success = [];
    this.showLoading = false;
    this.errors = errors.messages;
  }
}
